import React from 'react';
import {Typography} from '@material-ui/core';
import {
    ApTimelineThumbnail,
    ApTimelineRow,
    ApTimelineThumbnails,
} from '@accurate-player/accurate-player-components-external';

import './Thumbnails.scss';

ApTimelineRow.register();
ApTimelineThumbnail.register();
ApTimelineThumbnails.register();

export interface ThumbnailsProps {
    setThumbnailsRef: () => void;
    setThumbnailsContainerRef: () => void;
}

export default function Thumbnails(props: ThumbnailsProps) {
    const {setThumbnailsRef, setThumbnailsContainerRef} = props;
    
    return (
        <ap-timeline-row>
            <span
                slot="header"
                className="row-header"
            >
                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                    Thumbnails
                </Typography>
            </span>
            <ap-timeline-thumbnails
                className="thumbnails-container"
                height="50"
                ref={setThumbnailsContainerRef}
            >
                <ap-timeline-thumbnail ref={setThumbnailsRef} />
            </ap-timeline-thumbnails>
        </ap-timeline-row>
    );
}
